import axios from '../utils/request.js'

export function getNumDetial(detialVo) {
    return axios({
        url: '/server/detail',
        method: 'post',
        data: detialVo ,
        withCredentials: true
    })
}

export function getNewsLsit(news) {
    return axios({
        url: '/server/news',
        method: 'post',
        data: news,
        withCredentials: true
    })
}

export function newsInfo(idVo) {
    return axios({
        url: '/server/news/info',
        method: 'post',
        data: idVo,
        withCredentials: true
    })
}
